import React from 'react';
import { MenuItem } from '@mui/material';
import { MONTHS } from '../../../../Constants';
import { generateYearsOptions } from '../../../../../../utils/generators';

const renderMonths = ():React.ReactNode => {
  // remove first el from arr, from backend months is start from 1
  return MONTHS.slice(1, MONTHS.length).map((month:string, idx: number) => (
    <MenuItem key={ month } value={ (idx + 1).toString() }>
      {month}
    </MenuItem>
  ));
};

const renderYears = ():JSX.Element[] => {
  return generateYearsOptions().map((year:string) => (
    <MenuItem key={ year } value={ year }>
      {year}
    </MenuItem>
  ));
};

export {
  renderMonths,
  renderYears,
};
